import { FC } from 'react';

import { CallOffOrderDetail } from '@ravago/shared/page-data/models/elements';
import { OrderPriceInfoRow } from '@ravago/shared/page-elements-radiance/components/shared/order/order-price-info-row';
import { Box } from '@ravago/shared/radiance/components/box/components/Box/Box';
import { Table } from '@ravago/shared/radiance/components/table/components/Table/Table';
import { TableBody } from '@ravago/shared/radiance/components/table/components/TableBody/TableBody';
import { TableCell } from '@ravago/shared/radiance/components/table/components/TableCell/TableCell';
import { TableRow } from '@ravago/shared/radiance/components/table/components/TableRow/TableRow';
import { Typography } from '@ravago/shared/radiance/components/typography/components/Typography/Typography';
import { useFormatter, useTranslations } from '@ravago/shared/translations/client';

interface Props {
  callOffOrderDetail: CallOffOrderDetail;
  usesAgreementApp: boolean;
  canViewPrices: boolean;
  showTotalQuantity?: boolean;
}

const CallOffProductInfo: FC<Props> = ({ callOffOrderDetail, usesAgreementApp, canViewPrices, showTotalQuantity = false }: Props) => {
  const translate = useTranslations();
  const format = useFormatter();

  return (
    <Box direction="column">
      <Table stroked="horizontal" tableLayout="fixed" hover={false} rowDividers={false}>
        <TableBody>
          <TableRow>
            <TableCell>
              <Typography component="b" variant="small-highlight" color="primary">
                {translate('page-consumer.call-off-agreement-flyout.your-order-reference')}
              </Typography>
            </TableCell>
            <TableCell>
              <Typography variant="small">{callOffOrderDetail.customerOrderReferences[0] || '-'}</Typography>
            </TableCell>
          </TableRow>
          {showTotalQuantity && (
            <TableRow>
              <TableCell>
                <Typography component="b" variant="small-highlight" color="primary">
                  {usesAgreementApp ? translate('page-consumer.call-off-agreement-flyout.total-quantity') : translate('my-orders.remaining-quantity')}
                </Typography>
              </TableCell>
              <TableCell>
                <Typography variant="small">{format.quantity(callOffOrderDetail.totalQuantity)}</Typography>
              </TableCell>
            </TableRow>
          )}
          <TableRow>
            <TableCell>
              <Typography component="b" variant="small-highlight" color="primary">
                {translate('page-consumer.call-off-agreement-flyout.packaging')}
              </Typography>
            </TableCell>
            <TableCell>
              <Typography variant="small">{callOffOrderDetail.packagings[0] || '-'}</Typography>
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell>
              <Typography component="b" variant="small-highlight" color="primary">
                {translate('page-consumer.call-off-agreement-flyout.colour')}
              </Typography>
            </TableCell>
            <TableCell>
              <Typography variant="small">{translate(`colors.${callOffOrderDetail.product.color.toLowerCase().replace(' ', '-')}`) + (callOffOrderDetail.product.producerColor ? ` - ${callOffOrderDetail.product.producerColor}` : '')}</Typography>
            </TableCell>
          </TableRow>
          <OrderPriceInfoRow unitPrice={callOffOrderDetail.unitPrice} isUnitPriceFixed={callOffOrderDetail.isUnitPriceFixed} canViewPrices={canViewPrices} />
          <TableRow>
            <TableCell>
              <Typography component="b" variant="small-highlight" color="primary">
                {translate('page-consumer.call-off-agreement-flyout.comment')}
              </Typography>
            </TableCell>
            <TableCell>
              <Typography variant="small">{callOffOrderDetail.orderConfirmationTexts.join(' • ') || '-'}</Typography>
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </Box>
  );
};

export default CallOffProductInfo;
